import { useQuery } from '@tanstack/react-query';
import BaseFetchOptions from 'src/data/api/common/BaseFetchOptions';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';

export const FETCH_TICKET_LINK_IMPORTS_QUERY_KEY = 'FETCH_TICKET_LINK_IMPORTS';

export const useFetchTicketLinkImports = (
    bookingOptionId: string | null,
    options?: BaseFetchOptions
) => {
    return useQuery({
        queryKey: [FETCH_TICKET_LINK_IMPORTS_QUERY_KEY, bookingOptionId, options],
        queryFn: () => ticketLinkImportService.getTicketLinkImports(bookingOptionId!, options),
        enabled: bookingOptionId !== null,
        keepPreviousData: true,
    });
};
